import styled from "styled-components";



export const CdpublicidadeBanner = styled.div`
padding-top: 8px;
display: flex;
align-items: center;

button{
  background-color: transparent;
  border: none;
}

.icons{
  font-size: 2rem;
  margin-left: 1rem;
  margin-right: 1rem;
  color: #313131;
}

.icons:hover{
  color: #423e3e;
}

.imgBanner{
  width: 100%;
}

img {
    margin: 0 auto;
    width: 100%;
}

.testeimagembanner{
  width: 100%;
  height: 100%;
}

@media (min-width: 376px) and (max-width: 436px) {
  .testeimagembanner{
    width: 100%;
    /* height: 250px */
  }
}



/* Slideshow container */
.slideshow-container {
  max-width: 100%;
  /* position: relative; descomentar */
  margin: auto;
}

/* Caption text */
.text {
  color: #f2f2f2;
  font-size: 15px;
  padding: 8px 12px;
  position: absolute;
  bottom: 8px;
  width: 100%;
  text-align: center;
}

/* Number text (1/3 etc) */
.numbertext {
  color: #f2f2f2;
  background-color: red;
  font-size: 12px;
  padding: 8px 12px;
  position: absolute;
  top: 0;
}

/* The dots/bullets/indicators */
.dot {
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
}

.actived {
  background-color: #717171;
}

/* Fading animation */
.fade {
  animation-name: fade;
  animation-duration: 1.5s;
}

@keyframes fade {
  from {opacity: .4} 
  to {opacity: 1}
}

/* On smaller screens, decrease text size */
@media only screen and (max-width: 300px) {
  .text {font-size: 11px}
}

/* Next & previous buttons */
.prev, .next {

  cursor: pointer;
  position: absolute;
  /* top: 10%; */
  width: auto;
  /* margin-top: -22px; */
  padding: 16px;
  color: white;
  font-weight: bold;
  font-size: 18px;
  transition: 0.6s ease;
  border-radius: 0 3px 3px 0;
  user-select: none;
}

/* Position the "next button" to the right */
.next {
  right: 0;
  border-radius: 3px 0 0 3px;
}

/* On hover, add a black background color with a little bit see-through */
.prev:hover, .next:hover {
  background-color: rgba(0,0,0,0.8);
}
`;

export const Carousel = styled.div`
  /* position: absolute; */
  width: 100%;
  display: flex;

  .imgBanner{
    width: 90%;
    height: 350px;
  }
`;


export const Container = styled.div`
  color: #000000;
  top: 100px;
  margin-bottom: 4rem;
  margin-top: 3rem;

  @media (max-width: 325px) {
    max-width: 300px;
  }
`;

export const TituloSecao = styled.h3`
  padding: 20px;
  color: #313131;
  font-size: 26px;
  text-align: left;
  margin-bottom: 12px;
  text-align: center;
`;

export const ContainerLogin = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-family: Verdana, Arial, sans-serif;
  font-size: 14px;
  color: #555555;
  height: 100%;
`;

export const ContainerForm = styled(Container)`
  height: 720px;
  width: 100%;
  background-size: cover;
  background-color: #fafbfc;
  margin-top: 50px;

  @media (max-width: 923px) {
    height: 100%;
  }
`;

export const ContainerFlutuante = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px auto 24px;
  width: 800px;
  padding: 32px 40px;
  background: rgb(255, 255, 255);
  border-radius: 3px;
  box-shadow: rgb(0 0 0 / 10%) 0px 0px 10px;
  box-sizing: border-box;
  color: rgb(94, 108, 132);

  @media (max-width: 923px) {
    width: 100%;
    padding: 10px;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
`;

export const Tabela = styled.table`
  width: 100%;
  text-align: left;
  border-collapse: collapse;
  margin-bottom: 10px;

  td,
  th {
    border: 1px solid #000000;
    padding: 3px 10px;
  }

  thead {
    background-color: var(--tabelas-bg-color);
  }

  thead th {
    color: #ffff;
    text-align: center;
    padding: 3px 10px;
  }

  tbody tr:nth-child(odd) {
    background: #ffffff;
  }
  tbody tr:nth-child(even) {
    background: #f3f3f3;
  }

  .icones,
  a {
    text-align: center;
    color: black;
  }

  .icones:hover,
  a:hover {
    color: #423e3e;
    cursor: pointer;
  }
`;

export const Formulario = styled.form`
  display: flex;
  flex-direction: column;
  margin: 0px auto 24px;
  width: 400px;
  padding: 32px 40px;
  background: rgb(255, 255, 255);
  border-radius: 3px;
  box-shadow: rgb(0 0 0 / 10%) 0px 0px 10px;
  box-sizing: border-box;
  color: rgb(94, 108, 132);

  @media (max-width: 923px) {
    width: 100%;
    padding: 10px;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
`;

export const FormPesquisa = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 2rem;

  input {
    padding: 10px;
    width: 100%;
  }
`;


export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify_content: center;
  align-items: center;
  z-index: 9999;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 500px;
  max-width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 10px rgba(0,0,0,0.3);
  position: relative;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 15px;

  h2 {
    margin: 0;
    font-size: 1.2rem;
    color: #333;
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
  &:hover { color: #ED3237; }
`;

export const ModalBody = styled.div`
  p { margin: 8px 0; color: #555; }
  strong { color: #333; }
`;

